import { API } from './api';
import { Coordinates, DefaultResponse } from './types';

export type Clima = {
  hoje: ClimaDia;
  amanha: ClimaDia;
  unidades: Unidades;
};

export type ClimaDia = {
  por_hora: ClimaHora[];
  precipitacao: number;
  temperatura_maxima: number;
  temperatura_minima: number;
  umidade: number;
  vento: number;
  rajada_max: number 
};

export type ClimaHora = {
  hora: string;
  precipitacao: number;
  temperatura: number;
  umidade: number;
  vento: number;
  rajada: number;
};

export type Unidades = {
  precipitacao: string;
  temperatura: string;
  umidade: string;
  vento: string;
  rajada: string;
};

export class ClimaService {
  public async getWeatherForecast({
    lat,
    lon,
  }: Coordinates): Promise<DefaultResponse<Clima>> {
    try {
      const { data } = await API.get<DefaultResponse<Clima>>('/clima', {
        params: { latitude: lat, longitude: lon },
      });
      return data;
    } catch (error) {
      console.error('Error fetching weather data:', error);
      return {
        mensagem: 'Erro ao obter dados climáticos.',
        sucesso: false,
      };
    }
  }
}
